<template>
  <li
    v-if="checkRole(item)"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
    }"
  >
    <!-- <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      v-if="item.role && $store.state.app.roles == item.role"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate"> {{ t(item.title) }} </span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link> -->
    <b-link v-bind="linkProps" class="d-flex align-items-center">
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate"> {{ $t(item.title) }} </span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from "@core/libs/acl";
import { BLink, BBadge } from "bootstrap-vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import useVerticalNavMenuLink from "./useVerticalNavMenuLink";
import mixinVerticalNavMenuLink from "./mixinVerticalNavMenuLink";
import permissionChecker from "@/mixins/permissionChecker";

export default {
  mixins: [permissionChecker],

  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    checkRole(item) {
      const userRoles = this.$store.state.app.roles;

      if (
        (this.$store.state.auth.permissions.includes(this.item.permission) &&
          userRoles.includes(item.role)) ||
        userRoles == "super-admin"
      ) {
        return true;
      } else if (
        this.$store.state.auth.permissions.includes(this.item.permission) &&
        !userRoles
      ) {
        return true;
      } else {
        return false;
      }
      // if (this.item.role) {
      //   if (this.$store.state.auth.roles[0] == 'admin') {
      //     return true
      //   }
      //   if (this.$store.state.auth.roles[0] == this.item.role) {
      //     return true
      //   }
      //   else if(this.$store.state.auth.permissions.includes(this.item.permission)){
      //     return true
      //   }
      //   else {
      //     return false
      //   }
      // }
      // return true;
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item
    );
    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuLink } = useAclUtils();

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
    };
  },
};
</script>
